import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/admin")({
  head: () => pageHead("page.admin"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    if (!context.auth?.user) {
      throw redirect({ to: "/sign-in" });
    }
    if (!context.auth.isSuperadmin) {
      throw redirect({ to: "/" });
    }
  },
});
